import axios from 'axios';
import router from '../router';
import store from '../store';
import { showError } from '../js/ui-helpers';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
});

const getHeaders = () =>
{
    const token = localStorage.getItem('accessToken')
    console.assert(token, "No token found in fetchWithBearerToken");
    return {
        'Authorization': `Bearer ${token}`,
    };
};

const accessTokenIsExpired = (error) =>
{
    return (
        error.response && error.response.data && 
        error.response.data.messages &&
        error.response.data.messages[0] &&
        error.response.data.messages[0].message==='Token is invalid or expired'
    );
};

const refreshTokenIsExpired = error =>
{
    return (
        error.config.url.includes("api/token/refresh") &&
        error.response && error.response.data &&
        error.response.data.detail==="Token is invalid or expired"
    );
};

const is404Error = error =>
{
    return error.response && error.response.status===404;
}

const isPermissionError = error =>
{
    return error.response && [401,403].includes(error.response.status);
}

const handCommonErrors = (error, {raise404=false}) =>
{
    if (!error.response)
    {
        showError('Connection Error', "Couldn't connect to server. Please check your internet connection");
    }
    else if (is404Error(error) && raise404) 
    {
        router.push({name: 'notfound'});
    }
    else if (isPermissionError(error))
    {
        showError('Permission Error', "You don't have the permission to do that.");
    }
    throw error;
}

export const fetchWithAuthToken = async (url, config={}, {raise404=false}={}) =>
{
    try
    {
        return await axiosInstance.get(url, {
            headers: getHeaders(),
            ...config,
        })
    }
    catch(error)
    {
        if (accessTokenIsExpired(error))
        {
            // await store.dispatch("users/refreshAccessToken", null, {root: true});
            await store.dispatch("users/refreshAccessToken");
            return axiosInstance.get(url , {
                headers: getHeaders(),
                ...config,
            });
        }
        handCommonErrors(error, {raise404});
    }
};

export const postWithAuthToken = async (url, data, config={}, {logOutIfFail=true, raise404=false}={}) =>
{
    try
    {
        return await axiosInstance({
            headers: getHeaders(),
            method: 'POST',
            ...config,
            url,
            data,
        });
    }
    catch(error)
    {
        if (logOutIfFail && refreshTokenIsExpired(error))
        {
            store.dispatch('users/logOut');
            return error;
        }
        
        if (accessTokenIsExpired(error))
        {
            await store.dispatch("users/refreshAccessToken");
            return await postWithAuthToken(url, data, config);
        }
        handCommonErrors(error, {raise404});
    }
};

export const noResponseErrorMsg = "Couldn't connect to server. Please check your internet connection";

export default axiosInstance;
